CreateSecurityQuestionsController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    'pagePushService',
    'accountService',
];

// eslint-disable-next-line @treasury/filename-match-export
export default function CreateSecurityQuestionsController(
    $scope,
    $state,
    $stateParams,
    pagePushService,
    accountService
) {
    $scope.confirmSecurityQuestionsState = false;

    $scope.user = {
        challenges: [],
    };

    $scope.getQuestionValue = function (securityQuestionId) {
        let result = '';
        angular.forEach($scope.user.availableQuestions, securityQuestion => {
            if (securityQuestion.id === securityQuestionId) {
                result = securityQuestion.text;
            }
        });
        return result;
    };

    $scope.confirmSecurityQuestions = function () {
        $scope.confirmSecurityQuestionsState = true;
        setLabels();
    };

    $scope.editSecurityQuestions = function () {
        $scope.confirmSecurityQuestionsState = false;
        setLabels();
    };

    $scope.message = '';

    $scope.reset = function () {
        init();
        $scope.form.$setPristine();
    };

    $scope.resetAnswer = function (question) {
        if (question.id === null) {
            question.answer = null;
        }
    };

    function setLabels() {
        if ($scope.confirmSecurityQuestionsState === false) {
            $scope.headerText = 'Security Questions';
        } else {
            $scope.headerText = 'Confirm Security Questions';
        }
    }

    $scope.processSecurityQuestions = function () {
        accountService.saveSecurityQuestions($scope.user.challenges).then(response => {
            if (response !== false) {
                accountService.goToNextStep();
            }
        });
    };

    $scope.initialize = function (form) {
        $scope.form = form;
    };

    $scope.areSecurityQuestionsAnswered = function () {
        let result = true;
        if ($scope.user !== null) {
            angular.forEach($scope.user.challenges, challenge => {
                if (challenge.id === null) result = false;
            });
        }

        return result;
    };

    $scope.determineAvailableQuestions = function (availableQuestions, questionIndex) {
        const result = [];
        let otherQuestions = [];
        const index = 0;
        questionIndex *= 10;
        otherQuestions = availableQuestions.slice(questionIndex, questionIndex + 10);
        return otherQuestions;
    };

    function init() {
        $scope.user = pagePushService.getUser();
        if ($scope.user === null || $scope.user === undefined) {
            $state.go('login');
            return;
        }
        $scope.securityQuestions = shuffleArray($scope.user.credential.data);
        function shuffleArray(array) {
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                const temp = array[i];
                array[i] = array[j];
                array[j] = temp;
            }
            return array;
        }

        $scope.user.availableQuestions = angular.copy($scope.securityQuestions);

        if ($scope.user.availableQuestions[0].id !== -1) {
            $scope.user.challenges = [];
            for (let step = 1; step <= $scope.user.credential.numberOfSecurityQuestions; step++) {
                $scope.user.challenges.push({ id: null, answer: null });
            }
        } else {
            angular.forEach($scope.user.challenges, challenge => {
                challenge.id = null;
                challenge.answer = null;
            });
        }

        setLabels();
    }

    init();
}
